import bootstrap_img from "../tech/Bootstrap.png";
import Figma from "../tech/Figma.png";
import git from "../tech/Git.png";
import Jquery from "../tech/JQuery.png";
import js from "../tech/JS.png";
import laravel from "../tech/laravel.png";
import MySQL from "../tech/MySQL.png";
import MongoDB from "../tech/mongoDB.png";
import nodeJS from "../tech/Node.js.png";
import php from "../tech/php.png"
import react_img from "../tech/react.png";
import sass from "../tech/sass.png"; 
import html from "../tech/html-5.png";
import css from "../tech/css-3.png";
import photoshop from "../tech/photoshop.png";
import illustrator from "../tech/illustrator.png"

export const technologies = [
    {
        cover: react_img,
        name: 'ReactJS',
        stack: 'front-end'
    },
    {
        cover: js,
        name: 'JavaScript',
        stack: 'front-end'
    },
    {
        cover: Jquery,
        name: 'JQuery',
        stack: 'front-end'
    },
    {
        cover: sass,
        name: 'SASS',
        stack: 'front-end'
    },
    {
        cover: bootstrap_img,
        name: 'Bootstrap',
        stack: 'front-end'
    },
    {
        cover: nodeJS,
        name: 'nodeJS',
        stack: 'back-end'
    },
    {
        cover: laravel,
        name: 'laravel',
        stack: 'back-end'
    },
    {
        cover: MySQL,
        name: 'MySQL',
        stack: 'back-end'
    },
    {
        cover: php,
        name: 'php',
        stack: 'back-end'
    },
    {
        cover: MongoDB,
        name: 'MongoDB',
        stack: 'back-end'
    },
    {
        cover: Figma,
        name: 'Figma',
        stack: 'design'
    },
    {
        cover: git,
        name: 'git',
        stack: ''
    },
    {
        cover: html,
        name: 'HTML',
        stack: 'front-end'
    },
    {
        cover: css,
        name: 'CSS',
        stack: 'front-end'
    },
    {
        cover: photoshop,
        name: 'Photoshop',
        stack: 'design'
    },
    {
        cover: illustrator,
        name: 'Illustrator',
        stack: 'design'
    }
]